import { Nav } from "react-bootstrap";
import {
  BuildingUp,
  CartCheck,
  HouseUp,
  PencilSquare,
  PlusCircle,
  CardChecklist,
} from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { to: "/home", icon: HouseUp, label: "Home" },
  { to: "/register", icon: PencilSquare, label: "Add" },
  { to: "/vendors", icon: CartCheck, label: "Vendors" },
  { to: "/connect", icon: PlusCircle, label: "Connect" },
  { to: "/categories", icon: CardChecklist, label: "Browse" },
  { to: "/admin", icon: BuildingUp, label: "Business" },
];

const MobileBar = () => {
  const location = useLocation();

  return (
    <div className="mobile-bar">
      {navItems.map(({ to, icon: Icon, label }) => (
        <Nav.Link
          key={to}
          as={Link}
          to={to}
          className={`mobile-bar-link ${
            location.pathname === to ? "active" : ""
          }`}
        >
          <Icon />
          <span className="mobile-bar-label">{label}</span>
        </Nav.Link>
      ))}
    </div>
  );
};

export default MobileBar;
